import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { useForm } from 'react-hook-form';
import { productTypeValidationForm } from '../../../utils/validationSchema';
import Form from '../../../layouts/Form';
import PaymentMethodForm from './PaymentMethodForm';

const EditPaymentMethod= (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<any>({
    resolver: yupResolver(productTypeValidationForm),
    defaultValues: async () => {
      let data: any = await props?.refetch()
      return {
        ...data?.data
      }
    }
  });
  const { handleEdit, isLoading } = props;
  return (
    <Form
      handleSubmit={handleSubmit}
      handleFormSubmit={handleEdit}
      setError={setError}
      buttonLabel={"Update"}
      isLoading={isLoading}
    >
      <PaymentMethodForm
        errors={errors}
        register={register}
      />
    </Form>

  );
}

export default EditPaymentMethod
